const form_anchor_buttons = document.querySelectorAll('[data-target-form]');
const form_buttons = document.querySelectorAll('[data-form-button]');
const forms = document.querySelectorAll('[data-form]');

function toggleForm(form, button) {
	forms.forEach(f => {
		f.classList.remove('active');
	});
	form_buttons.forEach(b => {
		b.classList.remove('active');
	});
	if (form && button) {
		form.classList.add('active');
		button.classList.add('active');
	}
}

form_anchor_buttons.forEach(btn => {
	btn.addEventListener('click', () => {
		const form = document.querySelector(`[data-form="${btn.dataset.targetForm}"]`);
		const button = document.querySelector(`[data-form-button="${btn.dataset.targetForm}"]`);
		toggleForm(form, button);
	})
})

form_buttons.forEach(button => {
	button.addEventListener('click', function(event) {
		event.preventDefault();
		const form = document.querySelector(`[data-form="${this.dataset.formButton}"]`);
		toggleForm(form, button);
	});
});
